import { combineReducers } from 'redux';
import { keyBy } from 'lodash';

import {
  fetchNotificationTypes,
  fetchNotificationPageTypes,
  notificationMarkReadTypes,
  SUBSCRIBE_TO_NOTIFICATION,
} from './action_types';

import { makeRequestReducer } from '../../config/client';

const subscriptionReducer = (state, { type, payload }) => {
  if (type === SUBSCRIBE_TO_NOTIFICATION) {
    if (!payload) return state;
    return { ...state, data: {
      ...state.data,
      unread: (state.data.unread || 0) + 1,
      count: (state.data.count || 0) + 1,
      notification: [payload, ...(state.data.notification || [])],
    } };
  }
  return state;
};

const main = makeRequestReducer({
  types: fetchNotificationTypes,
  name: 'fetchNotification',
  append: [subscriptionReducer],
});

const page = makeRequestReducer({
  types: fetchNotificationPageTypes,
  name: 'fetchNotification',
  append: [subscriptionReducer],
})

export default combineReducers({
  main,
  page,
});



// WEBPACK FOOTER //
// ./src/modules/notification/reducers.js